module.exports = __webpack_public_path__ + "ota-icons.599593b33bca1c4bdfa3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-icons/fonts/ota-icons.woff?xst5zg
// module id = 1378
// module chunks = 24